import * as Type from './actionsTypes';

const INITIAL_STATE = {
  job: null,
  nsirId: null,
  uploading: false,
  documento: null,
  conflict: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.PARSE_RFG_START:
      return {
        ...state,
        uploading: true,
        nsirId: action.nsirId || state.nsirId,
        conflict: null,
      };
    case Type.PARSE_RFG_START_SUCCESS:
      return {
        ...state,
        uploading: false,
        job: action.job || state.job,
        nsirId: action.nsirId || state.nsirId,
        conflict: null,
        documento: null,
      };
    case Type.PARSE_RFG_FETCH_SUCCESS:
      return {
        ...state,
        uploading: false,
        job: action.job,
        nsirId: action.nsirId || state.nsirId,
        conflict: null,
      };
    case Type.PARSE_RFG_START_CONFLICT:
      return {
        ...state,
        uploading: false,
        conflict: action.message || true,
      };
    case Type.PARSE_RFG_CLEAR_CONFLICT:
      return {
        ...state,
        conflict: null,
      };
    case Type.PARSE_RFG_START_ERROR:
      return {
        ...state,
        uploading: false,
      };
    case Type.PARSE_RFG_FETCH_DOCUMENTO_SUCCESS:
      return {
        ...state,
        documento: action.documento || null,
      };
    case Type.PARSE_RFG_CLEAN:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export const getParseRfgJob = (state) => state.rootState.parseRfg.job;
export const getParseRfgUploading = (state) => state.rootState.parseRfg.uploading;
export const getParseRfgNsirId = (state) => state.rootState.parseRfg.nsirId;
export const getParseRfgDocumento = (state) => state.rootState.parseRfg.documento;
export const getParseRfgConflict = (state) => state.rootState.parseRfg.conflict;
